import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Button } from 'base-ui'

import { useOpenableControls } from '../../../../generic-hooks'
import { IconShare } from '../../../../icons'

import { ProductBuyBoxSocialPopupModal } from './ProductBuyBoxSocialPopupModal'

export const ProductBuyBoxSocialPopup: FC = () => {
  const { handleClose, handleOpen, isOpen } = useOpenableControls(false)

  return (
    <>
      <Button
        onClick={handleOpen}
        size="medium"
        startIcon={<IconShare />}
        type="button"
        variant="text"
      >
        <FormattedMessage id="general.label.day.share" />
      </Button>
      <ProductBuyBoxSocialPopupModal
        handleClose={handleClose}
        isOpen={isOpen}
      />
    </>
  )
}
